import './Celebration.css';

const COLORS = ['#004df2', '#2e7d32', '#e65100', '#c62828', '#7b2d9a', '#00838f', '#f4a261', '#ffd166'];
const PIECES = 80;

// A lightweight, dependency-free confetti burst shown when a request is
// resolved. Rendered as a fixed, pointer-events-none overlay above the dialog;
// the parent unmounts it after the animation window.
const Celebration = ({ show }) => {
    if (!show) return null;
    const pieces = [];
    for (let i = 0; i < PIECES; i++) {
        const style = {
            left: `${Math.random() * 100}%`,
            width: `${6 + Math.random() * 8}px`,
            height: `${8 + Math.random() * 8}px`,
            backgroundColor: COLORS[i % COLORS.length],
            animationDelay: `${Math.random() * 0.35}s`,
            animationDuration: `${1.2 + Math.random() * 1}s`,
            borderRadius: Math.random() > 0.5 ? '2px' : '50%',
        };
        pieces.push(<span key={i} className="confetti-piece" style={style} />);
    }
    return (
        <div className="celebrate-overlay" aria-hidden="true">
            {pieces}
            <div className="celebrate-badge">✓ Resolved!</div>
        </div>
    );
};

export default Celebration;
